
import $api from '@/api'
import auth from '@/utils/auth'

const state = {
	userInfo: auth.getToken(),
	configInfo: {}, // 配置信息
	deviceInfo: {}, // 设备信息
  packageInfo: {} // 游戏信息
}

const mutations = {
	SET_USER_INFO: (state, data) => {
		state.userInfo = data
    auth.setToken(data)
	},
	SET_CONFIG_INFO: (state, data) => {
		state.configInfo = data
	},
	SET_DEVICE_INFO: (state, data) => {
		state.deviceInfo = data
	},
	SET_PACKAGE_INFO: (state, data) => {
		state.packageInfo = data
	}
}

const actions = {
  // 初始化
	init({ commit }, env) {
		return new Promise((resolve) => {
      const params = {
        data: {
          env: parseInt(env)
        },
        device: state.deviceInfo,
        package: state.packageInfo
      }
      $api.init(params).then(res => {
        const { data } = res
        commit('SET_CONFIG_INFO', data)
        resolve()
      })
		})
	},

  // 退出登录
  logout({ commit }) {
    return new Promise(resolve => {
      commit('SET_USER_INFO', {})
      auth.removeToken()
      resolve()
    })
  }
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
